<div class="wrap">
    <div class="container">
        <app-header></app-header>
    </div>
    <div class="aviso-container flex flex-col space-y-10 pt-36">
        <div class="max-w-4xl mx-auto">
            <h1 className="text-xl font-bold text-customPurple-600 mb-4 text-center" style="text-align: center;">
                Promoción Renovación
            </h1>

            <div className="space-y-6 text-customBlack-500">

                <h2 className="text-lg font-bold text-customPurple-600 mb-2">
                    Beneficio
                </h2>
                <p className="text-justify">
                    10% de descuento sobre el total de intereses del crédito de la siguiente renovación.
                    <br />El descuento se aplica al calcular el monto para liquidar en el último pago, reflejándose en
                    el importe del último pago.
                    <br />El descuento aplica solo a intereses (no incluye capital, comisiones, IVA, seguros u otros
                    cargos).
                </p>

                <h2 className="text-lg font-bold text-customPurple-600 mb-2">
                    Elegibilidad
                </h2>
                <p className="text-justify">
                    Promoción exclusiva por invitación.
                    <br>Válida únicamente en tu siguiente renovación
                    <br>Aplica únicamente a una renovación por cliente durante la vigencia.
                    <br>Renovación sujeta a aprobación y validación conforme a políticas internas.

                </p>

                <h2 className="text-lg font-bold text-customPurple-600 mb-2">
                    Condiciones de cumplimiento
                </h2>
                <p className="text-justify">
                    Para conservar el beneficio, el cliente debe cumplir con el calendario de pagos (sin atrasos) del
                    crédito vigente y mantener su renovación al corriente.
                    <br>Si existe mora, convenio, reestructura o la cuenta se encuentra en cobranza, la promoción
                    puede no aplicar.
                </p>

                <h2 className="text-lg font-bold text-customPurple-600 mb-2">
                    Vigencia
                </h2>
                <p className="text-justify">
                    Válido por un periodo maximo de 60 dias desde la liquidación de tu credito. En caso de no tener un
                    crédito abierto, 60 días a partir de recibir la comunicación.
                    <br>El beneficio se aplica en el último pago del crédito renovado, siempre que el desembolso
                    haya ocurrido dentro de la vigencia y se hayan cumplido las condiciones.
                </p>

                <h2 className="text-lg font-bold text-customPurple-600 mb-2">
                    Restricciones
                </h2>
                <p className="text-justify">
                    No acumulable con otras promociones o descuentos.
                    <br>No canjeable por efectivo y no transferible.
                    <br>Teu Technologies SAPI de CV, se reserva el derecho de cancelar, suspender o modificar la
                    promoción sin previo aviso.
                </p>

                <h2 className="text-lg font-bold text-customPurple-600 mb-2">
                    Comunicación
                </h2>
                <p className="text-justify">
                    La recepción del mensaje no garantiza aprobación.
                </p>
            </div>
        </div>
    </div>
    <app-footer [colorClass]="footerColorClass"></app-footer>
</div>